import { Component, OnInit, ViewChild, ElementRef, Directive, Input, Output, EventEmitter, forwardRef, DoCheck, Injector, HostBinding } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatFormFieldControl, MatTooltip } from '@angular/material';
import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordFieldComponent),
      multi: true
    },
    {
      provide: MatFormFieldControl,
      useExisting: PasswordFieldComponent
    }
  ]
})
export class PasswordFieldComponent implements OnInit, ControlValueAccessor, MatFormFieldControl<any>, DoCheck {

  @ViewChild('password', { static: false }) passwordInput: ElementRef;
  @ViewChild('MatTooltip', { static: false }) myTooltip;

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(plh) {
    this._placeholder = plh;
    this.stateChanges.next();
  }
  @Input()
  get required() {
    return this._required;
  }
  set required(req) {
    this._required = coerceBooleanProperty(req);
    this.stateChanges.next();
  }
  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(dis) {
    this._disabled = coerceBooleanProperty(dis);
    this.stateChanges.next();
  }

  @Input() controlName: string;
  @Input() error: boolean = false;
  @Input() isAutoGenerable: boolean = true;

  @HostBinding() id = `app-password-field-${PasswordFieldComponent.nextId++}`;
  @HostBinding('attr.aria-describedby') describedBy = '';
  @HostBinding('class.floating')
  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }
  showEye: boolean = true;

  onChange: any = () => { };
  onTouched: any = () => { };

  _value: string = '';
  _placeholder: string;
  _required: boolean = false;
  _disabled: boolean = false;
  static nextId = 0;
  stateChanges = new Subject<void>();
  ngControl: NgControl;
  focused = false;
  errorState = false;
  controlType = 'app-password-field';

  isDisabled: boolean = false;
  wasFocused: boolean = false;

  constructor(public injector: Injector, public elRef: ElementRef, private fm: FocusMonitor /*private ngControl: NgControl*/) {
    fm.monitor(this.elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnInit() {
    this.ngControl = this.injector.get(NgControl); // Inject the ngControl with injector to avoid a cyclic dependecy
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; };
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  tooglePassword() {
    if (this.passwordInput.nativeElement.type === "password") {
      this.passwordInput.nativeElement.type = "text";
      this.showEye = false;
    } else {
      this.passwordInput.nativeElement.type = "password";
      this.showEye = true;
    }
  }

  copyPassword() {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.passwordInput.nativeElement.value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (this.myTooltip) {
      this.myTooltip.show();
    }
    
  }

  generatePassword() {
    let generatedPass = Math.random().toString(36).slice(-8);

    this.onChange(generatedPass);
    this.onTouched();

    this.value = generatedPass;

    //Visualizar el texto de la contraseña
    this.passwordInput.nativeElement.type = "text";
    this.showEye = false;
  }

  writeValue(obj: string): void {
    this.value = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInputChanged($event): void {
    this.onChange($event.target.value);
    this.onTouched();

    this.value = $event.target.value;
  }

  ngDoCheck(): void {
    if (this.ngControl) {
      this.errorState = this.ngControl.invalid && this.ngControl.touched;
      this.stateChanges.next();

      if (this.wasFocused && !this.focused) {
        this.onTouched();
        this.wasFocused = false;
      }
    }
  }

  get value(): string {
    return this._value;
  }

  set value(value) {
    this._value = value;
    this.stateChanges.next();
  }

  get empty() {
    return this._value === '';
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      this.elRef.nativeElement.querySelector('input').focus();
    }
    this.wasFocused = true;
  }
}
